import { ImageRenderer } from "./image-renderer";
import { PDFRenderer } from "./pdf-renderer";

export const makeRenderer = (media, pageIndex) => {
  if (media.isImage()) {
    return new ImageRenderer(media);
  }
  return new PDFRenderer(media, pageIndex);
};
